(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["EbikoVIPChart"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.ebiko-vip-graph__container');
  const tierColumns = container.querySelectorAll('.tier-column');

  tierColumns.forEach(column => {
    column.addEventListener('mouseenter', function() {
      container.classList.add('highlighting');
    });

    column.addEventListener('mouseleave', function() {
      container.classList.remove('highlighting');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-hub-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const signature = (values) => values.filter(Boolean).join('|');
    const matchesPrefix = (route, selected) => selected.every((value, index) => !value || route.values[index] === value);
    const exactMatch = (route, selected, count) => selected.slice(0, count).every((value, index) => route.values[index] === value);

    const initialize = (root) => {
      if (root.dataset.finderInitialized === 'true') return;

      const config = root.querySelector('[data-finder-routes]');
      const steps = Array.from(root.querySelectorAll('[data-finder-step]'));
      const status = root.querySelector('[data-finder-status]');
      const fallback = root.querySelector('[data-finder-fallback]');
      const resultElements = Array.from(root.querySelectorAll('[data-route-result]'));
      const count = Number(root.dataset.stepCount);
      let routes = [];

      try {
        routes = JSON.parse(config.textContent);
      } catch (error) {
        console.warn('Invalid brand finder route data', error);
      }

      if (!routes.length || !steps.length) {
        if (fallback) fallback.hidden = false;
        return;
      }

      const selected = Array(count).fill('');

      const clearResults = () => {
        resultElements.forEach((result) => { result.hidden = true; });
        if (fallback) fallback.hidden = true;
      };

      const renderResult = () => {
        clearResults();
        const complete = selected.slice(0, count).every(Boolean);
        if (!complete) {
          status.textContent = selected.some(Boolean) ? root.dataset.choosePrevious : '';
          return;
        }

        const route = routes.find((candidate) => exactMatch(candidate, selected, count));
        const result = route ? resultElements.find((element) => element.dataset.routeResult === route.result) : null;
        const hasProducts = result && Number(result.dataset.resultProducts) > 0;

        if (!route || !hasProducts) {
          status.textContent = root.dataset.noRoute;
          if (fallback) fallback.hidden = false;
          return;
        }

        result.hidden = false;
        status.textContent = result.querySelector('h3')?.textContent?.trim() || '';
      };

      const update = () => {
        let selectedAutomatically = true;

        while (selectedAutomatically) {
          selectedAutomatically = false;

          steps.forEach((step, index) => {
            const buttons = Array.from(step.querySelectorAll('[data-finder-choice]'));
            const previousComplete = selected.slice(0, index).every(Boolean);

            buttons.forEach((button) => {
              const candidate = selected.slice();
              candidate[index] = button.dataset.value;
              candidate.fill('', index + 1);
              const possible = routes.some((route) => matchesPrefix(route, candidate));

              button.disabled = !previousComplete || !possible;
              button.hidden = previousComplete && !possible;
              button.setAttribute('aria-pressed', String(selected[index] === button.dataset.value));
            });

            if (previousComplete && !selected[index]) {
              const available = buttons.filter((button) => !button.disabled && !button.hidden);
              if (available.length === 1) {
                selected[index] = available[0].dataset.value;
                available[0].setAttribute('aria-pressed', 'true');
                selectedAutomatically = true;
              }
            }
          });
        }

        renderResult();
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-finder-choice]');
        if (!button || button.disabled) return;

        const step = button.closest('[data-finder-step]');
        const index = Number(step.dataset.stepIndex);
        selected[index] = button.dataset.value;
        selected.fill('', index + 1);
        update();
      });

      document.addEventListener('brand-hub:workflow', (event) => {
        const match = steps[0]?.querySelector(`[data-finder-choice][data-value="${CSS.escape(event.detail.value)}"]`);
        if (!match) return;
        selected[0] = event.detail.value;
        selected.fill('', 1);
        update();
      });

      root.dataset.finderInitialized = 'true';
      root.classList.add('is-ready');
      update();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-brand-hub-finder]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-hub-pathways"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.pathwaysInitialized === 'true') return;
      const buttons = Array.from(root.querySelectorAll('[data-pathway-button]'));
      const panels = Array.from(root.querySelectorAll('[data-pathway-panel]'));

      const select = (key) => {
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.pathwayButton === key)));
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.pathwayPanel !== key;
        });
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-pathway-button]');
        if (button) select(button.dataset.pathwayButton);
      });

      root.dataset.pathwaysInitialized = 'true';
      if (buttons.length) select(buttons[0].dataset.pathwayButton);
    };

    document.querySelectorAll('[data-brand-pathways]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-brand-pathways]').forEach(initialize));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-hub-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.productsInitialized === 'true') return;
      const buttons = Array.from(root.querySelectorAll('[data-brand-filter]'));
      const products = Array.from(root.querySelectorAll('[data-brand-product]'));
      const status = root.querySelector('[data-brand-products-status]');

      const applyFilter = (button) => {
        const value = button.dataset.brandFilter;
        const tag = button.dataset.brandFilterTag.toLowerCase();
        let visible = 0;

        buttons.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === button)));
        products.forEach((product) => {
          const tags = product.dataset.brandTags.toLowerCase().split('|');
          const matches = value === 'all' || product.dataset.brandCategory === value || (tag && tags.includes(tag));
          product.hidden = !matches;
          if (matches) visible += 1;
        });

        if (status) status.textContent = `${visible} ${visible === 1 ? root.dataset.productSingular : root.dataset.productPlural}`;
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-brand-filter]');
        if (button) applyFilter(button);
      });

      root.addEventListener('change', (event) => {
        const select = event.target.closest('[data-brand-variant-select]');
        if (!select) return;
        const card = select.closest('[data-brand-card]');
        const option = select.options[select.selectedIndex];
        if (!card || !option) return;

        card.querySelectorAll('[data-brand-card-link]').forEach((link) => {
          link.href = option.value;
        });

        const price = card.querySelector('[data-brand-variant-price]');
        const comparePrice = card.querySelector('[data-brand-variant-compare-price]');
        const stock = card.querySelector('.ebk-brand-card__stock');
        const available = option.dataset.available === 'true';

        if (price) price.textContent = option.dataset.price;
        if (comparePrice) {
          comparePrice.textContent = option.dataset.comparePrice;
          comparePrice.hidden = !option.dataset.comparePrice;
        }
        if (stock) {
          stock.dataset.available = String(available);
          // Prefer the label the card snippet resolved in Liquid (it knows about
          // backorder); fall back to the section's in-stock/unavailable strings so
          // an older cached card still renders sensibly.
          stock.textContent = option.dataset.stockLabel || (available ? root.dataset.inStock : root.dataset.unavailableLabel);
          stock.dataset.backorder = option.dataset.backorder === 'true' ? 'true' : 'false';
          stock.style.color = option.dataset.stockColor || '';
        }
      });

      root.dataset.productsInitialized = 'true';
      if (buttons.length && products.length) {
        applyFilter(buttons.find((button) => button.getAttribute('aria-pressed') === 'true') || buttons[0]);
      }
    };

    document.querySelectorAll('[data-brand-products]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-brand-products]').forEach(initialize));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-hub-workflows"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const workflow = event.target.closest('[data-brand-workflow]');
    if (!workflow) return;

    const finder = document.querySelector('[data-brand-hub-finder]');
    if (!finder) return;

    event.preventDefault();
    workflow.dispatchEvent(new CustomEvent('brand-hub:workflow', {
      bubbles: true,
      detail: { value: workflow.dataset.brandWorkflow }
    }));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    finder.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebiko-clinic-builder"] && !Shopify.designMode) return;
  try {
    
  const initializeEbikoBuilder = (section) => {
    if (section.dataset.ebikoBuilderInitialized === 'true') return;
    const buttons = Array.from(section.querySelectorAll('[data-ebiko-zone-button]'));
    const panels = Array.from(section.querySelectorAll('[data-ebiko-zone-panel]'));

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const selected = button.dataset.ebikoZoneButton;
        buttons.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === button)));
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.ebikoZonePanel !== selected;
        });
      });
    });

    section.addEventListener('change', (event) => {
      const select = event.target.closest('[data-brand-variant-select]');
      if (!select) return;
      const card = select.closest('[data-brand-card]');
      const option = select.options[select.selectedIndex];
      if (!card || !option) return;

      card.querySelectorAll('[data-brand-card-link]').forEach((link) => { link.href = option.value; });
      const price = card.querySelector('[data-brand-variant-price]');
      const comparePrice = card.querySelector('[data-brand-variant-compare-price]');
      const stock = card.querySelector('.ebk-brand-card__stock');
      const available = option.dataset.available === 'true';

      if (price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice;
        comparePrice.hidden = !option.dataset.comparePrice;
      }
      if (stock) {
        stock.dataset.available = String(available);
        // Prefer the label the card snippet resolved in Liquid (it knows about
        // backorder); fall back to the section's in-stock/unavailable strings so
        // an older cached card still renders sensibly.
        stock.textContent = option.dataset.stockLabel || (available ? section.dataset.inStock : section.dataset.unavailableLabel);
        stock.dataset.backorder = option.dataset.backorder === 'true' ? 'true' : 'false';
        stock.style.color = option.dataset.stockColor || '';
      }
    });

    section.dataset.ebikoBuilderInitialized = 'true';
  };

  document.querySelectorAll('[data-ebiko-builder]').forEach(initializeEbikoBuilder);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-ebiko-builder]').forEach(initializeEbikoBuilder);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebiko-command-center"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ebiko-command]').forEach((section) => {
    const form = section.querySelector('[data-ebiko-search-form]');
    const input = section.querySelector('[data-ebiko-search-input]');
    const query = section.querySelector('[data-ebiko-search-query]');
    if (!form || !input || !query) return;

    form.addEventListener('submit', () => {
      const term = input.value.trim();
      query.value = term ? `vendor:"EBIKO Dental" ${term}` : 'vendor:"EBIKO Dental"';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebiko-merchandising"] && !Shopify.designMode) return;
  try {
    
  const initializeEbikoMerchandising = (section) => {
    if (section.dataset.ebikoMerchInitialized === 'true') return;

    section.addEventListener('change', (event) => {
      const select = event.target.closest('[data-brand-variant-select]');
      if (!select) return;
      const card = select.closest('[data-brand-card]');
      const option = select.options[select.selectedIndex];
      if (!card || !option) return;

      card.querySelectorAll('[data-brand-card-link]').forEach((link) => { link.href = option.value; });
      const price = card.querySelector('[data-brand-variant-price]');
      const comparePrice = card.querySelector('[data-brand-variant-compare-price]');
      const stock = card.querySelector('.ebk-brand-card__stock');
      const available = option.dataset.available === 'true';

      if (price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice;
        comparePrice.hidden = !option.dataset.comparePrice;
      }
      if (stock) {
        stock.dataset.available = String(available);
        // Prefer the label the card snippet resolved in Liquid (it knows about
        // backorder); fall back to the section's in-stock/unavailable strings so
        // an older cached card still renders sensibly.
        stock.textContent = option.dataset.stockLabel || (available ? section.dataset.inStock : section.dataset.unavailableLabel);
        stock.dataset.backorder = option.dataset.backorder === 'true' ? 'true' : 'false';
        stock.style.color = option.dataset.stockColor || '';
      }
    });

    section.dataset.ebikoMerchInitialized = 'true';
  };

  document.querySelectorAll('[data-ebiko-merchandising]').forEach(initializeEbikoMerchandising);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-ebiko-merchandising]').forEach(initializeEbikoMerchandising);
  });

  } catch(e) { console.error(e); }
})();
})();
